import { Component, OnInit } from '@angular/core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { faPhone, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { GoogleTagManagerService } from 'src/app/angular-google-tag-manager.service';
import { BlogService } from 'src/app/blog.service';
import { UserLocationData } from 'src/app/user-location-data.model';

@Component({
  selector: 'app-adhesive-banner',
  templateUrl: './adhesive-banner.component.html',
  styleUrls: ['./adhesive-banner.component.scss']
})
export class AdhesiveBannerComponent implements OnInit {

  faTimes = faTimes;
  adBanner: Record<string, any> = null;
  bannerLoading = true;
  bannerError = false;

  showAB = true;
  stateCode = "";
  faPhone = faPhone;
  faTriangleExclamation =faTriangleExclamation; 
	locationData: UserLocationData;
  
  constructor(
    public blogService: BlogService,
    private gtmService: GoogleTagManagerService,
  ) { }

  ngOnInit(): void {
    if (typeof window !== "undefined" && typeof document !== "undefined" && this.blogService.adhesiveBannersVisible) {
      this.blogService.userLocationData$
        .subscribe(loc => {
          this.locationData = loc;
          // if user's location is within the United States, retrieve their state
          if (loc.iso_code === "US") {
            this.stateCode = loc.state;
          } else {
            // otherwise default to New Jersey
            this.stateCode = "NJ";
          }
  
          this.blogService.getAdhesiveBanner(this.stateCode)
            .subscribe(banner => {
              this.adBanner = banner;
            }, (err) => {
  
            })
        }, (err) => {
  
        })

      
    }
  }
  
  openBanner(url: string, bookCode?: string): void {
    const gtmTag = {
      event: "exit",
      event_category: "adhesive",
      event_label: bookCode,
    };

    this.gtmService.pushTag(gtmTag)
      .then(() => {
        window.open(url, "_blank");
      })
      .catch(e => {
        console.error("Google Tag Manager Script failed: " + e)
        window.open(url, "_blank");
      });
  }

}
